import React from 'react';
import styles from '../../../styles.module.scss';
import {
    CheckBox,
    Flex,
    Icon,
    Input,
    Link,
    PriorityIcon,
    Text,
    Title
} from '@priority-software/priority-style-react';
import {texts} from '../../../../../../../texts';
import {
    getLocalizedText,
    texts as commonTexts
} from '../../../../../../../../../constants/TextConst';

type Props = {
    hasSearch: boolean;
    inputRef: React.RefObject<HTMLInputElement>;
    searchQuery: string;
    handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
    ignorecase?: boolean;
    searchByTitle?: string;
    handleIgnoreCaseChange?: () => void;
    handleSearchByChange?: (searchQuery: string) => void;
    handleSearchFromBeginningChange?: () => void;
    searchFromBeginning?: boolean;
    isSearchAsync?: boolean;
};

export const SearchHeader = (props: Props) => {
    const {
        hasSearch,
        inputRef,
        searchQuery,
        ignorecase,
        searchByTitle,
        searchFromBeginning,
        isSearchAsync,
        handleIgnoreCaseChange,
        handleSearchFromBeginningChange,
        handleSearchByChange,
        handleSearch
    } = props;

    return (
        <>
            {hasSearch && (
                <div className={styles.search}>
                    <Input
                        inputRef={inputRef}
                        autoFocus
                        roundedCorners
                        value={searchQuery}
                        onChange={handleSearch}
                        placeholder={texts.search_placeholder}
                    >
                        <Icon icon={PriorityIcon.searchThin} iconColor="secondary-400" />
                    </Input>
                </div>
            )}

            {isSearchAsync ? (
                <>
                    <div className={styles.headerBottom}>
                        <Flex componentClasses={styles.sortRow}>
                            <CheckBox checked={ignorecase} onChange={handleIgnoreCaseChange}>
                                <Text tag="span" skin="caption-2" textColor="secondary-400">
                                    <span className={styles.nowrap}>{texts.ignoreCase}</span>
                                </Text>
                            </CheckBox>

                            <CheckBox
                                checked={searchFromBeginning}
                                onChange={handleSearchFromBeginningChange}
                            >
                                <Text tag="span" skin="caption-2" textColor="secondary-400">
                                    <span className={styles.nowrap}>{texts.search_from_start}</span>
                                </Text>
                            </CheckBox>
                        </Flex>

                        {searchByTitle ? (
                            <Flex componentClasses={styles.categoryRow} alignItems="center">
                                <Title skin="h6" componentClasses={styles.title}>
                                    {getLocalizedText(commonTexts.searchPrefix)} {searchByTitle}
                                </Title>

                                <Link
                                    componentClasses={styles.link}
                                    onClick={() => handleSearchByChange(searchQuery)}
                                >
                                    {getLocalizedText(commonTexts.changeSearchByCategoryLabel)}
                                </Link>
                            </Flex>
                        ) : null}
                    </div>
                </>
            ) : null}
        </>
    );
};
